module.exports = __webpack_public_path__ + "img/mobileapp2.5821a3ea.svg";